import { TravelProposalMdl } from "./TravelProposalMdl";

export class TravelBindMdl
{
   public  zoneList: Array<zoneMdl>=new Array<zoneMdl>();
   public planList: Array<planMdl>=new Array<planMdl>();
   public genderList: Array<genderMdl>=new Array<genderMdl>();
   public insTypeList: Array<InsuredTypeMdl>=new Array<InsuredTypeMdl>();
   public natList: Array<NatMdl>=new  Array<NatMdl>();
   public occList: Array<OccuMdl>=new  Array<OccuMdl>();
   public cityList: Array<CityMdl>=new  Array<CityMdl>();
   public propoalObj: TravelProposalMdl=new TravelProposalMdl();
   public st: TravelstatusMdl=new TravelstatusMdl();
   public relList: Array<RelationMdl>=new  Array<RelationMdl>();
   public bankList: Array<BankMaster>=new  Array<BankMaster>();
   public destList: Array<DestinationMdl> = new Array<DestinationMdl>();
   public highPosList: Array<HigherPositionMdl> = new Array<HigherPositionMdl>();


}
export class HigherPositionMdl {
    PositionCode: number;
    Position_En: string;
    Position_Ar: string;
}
export class DestinationMdl {
    DestinationId: number;
    DestinationNameEn: string;
    DestinationNameAr: string;
    DestinationStatus: string;
}
export class zoneMdl
{
    public ZoneCode: string;
    public ZoneDescEn: string;
    public ZoneDescAr: string;

}
export class planMdl
{
    public PlanCode: number;
    public PlanDescEn: string;
    public PlanDescAr: string;
    public ZoneCode: string;

}
export class genderMdl
{
    public GenderCode: string;
    public GenderDescEn: string;
    public GenderDescAr: string;

}
export class InsuredTypeMdl
{
    public InsuredTypeCode: number;
    public InsuredTypeDescEn: string;
    public InsuredTypeDescAr: string;

}
export class NatMdl
{
    public NATCode: number;
    public NATNameEn: string;
    public NATNameAr: string;
    public CountryNameEn: string;
    public CountryNameAr: string;

}
export class OccuMdl
{
    public OccuCode: string;
    public OccuDescEn: string;
    public OccuDescAr: string;

}
export class CityMdl
{
    public CityCode: number;
    public CityNameEn: string;
    public CityNameAr: string;
    public RegCode: string;
    public RegDescEn: string;
    public RegDescAr: string;

}
export class RelationMdl
{
    public RelationID: number;
    public RelationNameEn: string;
    public RelationNameAr: string;
    public GenderCode:number;

}
export class BankMaster
{
    public BankCode: string;
    public BankDesc_Eng: string;
    public BankDesc_Ar: string;
    public CbidCode: string;
    public isSameCode: boolean;
}
export class TravelstatusMdl
{
    public StatusCode: string;
    public StatusDesc: string;
    public StatusDescAr: string;
    public msgKey: string;
    public Result: string;
}




// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/TravelBindMdl.ts